import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { common } from 'themes/default';

export const TabContainer = styled('div')`
  display: grid;
  position: relative;
  ${({ count }) => `grid-template-columns: repeat(${count}, 1fr);`};
  ${ifProp(
    'overflowScroll',
    css`
      overflow-x: scroll;
    `
  )};

  &::before {
    background-color: ${common.tabs.baseBorder};
    bottom: 0;
    content: '';
    display: block;
    height: 1px;
    left: 0;
    position: absolute;
    width: 100%;
  }
`;

export const StyledTabDisabledTooltip = styled.div`
  display: none;
`;

export const tabStyles = `
  position: relative;
  cursor: pointer;
  padding: 8px 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  white-space: nowrap;
  background-color: ${common.tabs.normal.backgroundColour};
  border: solid 1px ${common.tabs.normal.borderColour};
  color: ${common.tabs.normal.fontColour};

  &::after {
    background-color: ${common.tabs.normal.highlightColour};
    border-radius: 4px 4px 0 0;
    bottom: -1px;
    content: '';
    display: block;
    height: 4px;
    left: 0;
    position: absolute;
    width: 100%;
  }
`;

export const StyledTab = styled('div')`
  ${tabStyles}

  ${ifProp(
    'selected',
    css`
      color: white;
      background-color: ${common.tabs.active.backgroundColour};
      border: solid 1px ${common.tabs.active.borderColour};
      color: ${common.tabs.active.fontColour};

      &::after {
        background-color: ${common.tabs.active.highlightColour};
      }
    `
  )};

  ${ifProp(
    'disabled',
    css`
      &:before {
        content: '';
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: white;
        opacity: 0.5;
        cursor: not-allowed;
      }

      background-color: ${common.tabs.disabled.backgroundColour};
      border: solid 1px ${common.tabs.disabled.borderColour};
      color: ${common.tabs.disabled.fontColour};
    `
  )};
  ${ifProp(
    ['disabled', 'disabledOnHoverMessage'],
    css`
      &:hover {
        ${StyledTabDisabledTooltip} {
          display: block;
        }
      }
    `
  )};
`;
export const StyledTabButton = styled('button')`
  ${tabStyles}

  ${ifProp(
    'selected',
    css`
      color: white;
      background-color: ${common.tabs.active.backgroundColour};
      border: solid 1px ${common.tabs.active.borderColour};
      color: ${common.tabs.active.fontColour};

      &::after {
        background-color: ${common.tabs.active.highlightColour};
      }
    `
  )};

  &:focus {
    color: white;
    background-color: ${common.tabs.active.backgroundColour};
    border: solid 1px ${common.tabs.active.borderColour};
    color: ${common.tabs.active.fontColour};

    &::after {
      background-color: ${common.tabs.active.highlightColour};
    }
  }

  &:disabled {
    &:before {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: white;
      opacity: 0.5;
      cursor: not-allowed;
    }

    background-color: ${common.tabs.disabled.backgroundColour};
    border: solid 1px ${common.tabs.disabled.borderColour};
    color: ${common.tabs.disabled.fontColour};
  }
`;
